module.exports = __webpack_public_path__ + "img/kr-red-card-right-bottom-3.9542ddc.png";